import { useState } from "react";
import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

export default function FaqSection({ items, testPrefix = "faq" }) {
  const [open, setOpen] = useState(items.length ? "item-0" : "");
  return (
    <Reveal>
      <Accordion.Root type="single" collapsible value={open} onValueChange={setOpen} className="border-t border-line">
        {items.map((item, i) => (
          <Accordion.Item key={i} value={`item-${i}`} className="border-b border-line" data-testid={`${testPrefix}-accordion-item-${i + 1}`}>
            <Accordion.Header>
              <Accordion.Trigger className="group flex w-full items-center justify-between gap-6 py-6 text-left">
                <span className="font-serif text-lg text-ink transition-colors group-hover:text-pine sm:text-xl">{item.q}</span>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-line text-olive transition-transform duration-300 group-data-[state=open]:rotate-45">
                  <Plus className="h-4 w-4" />
                </span>
              </Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
              <p className="max-w-3xl pb-7 text-base leading-relaxed text-moss">{item.a}</p>
            </Accordion.Content>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </Reveal>
  );
}
